import { render } from "./ReflectionCriteria.vue?vue&type=template&id=7aee30b6"
import script from "./ReflectionCriteria.vue?vue&type=script&lang=js"
export * from "./ReflectionCriteria.vue?vue&type=script&lang=js"

import "./ReflectionCriteria.vue?vue&type=style&index=0&id=7aee30b6&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__